export const baseUrl = process.env.REACT_APP_HOLEDO_BASE_URL;
